import { Link } from "react-router-dom";
import { quickCategories } from "@/mocks/categories";

export default function SiteFooter() {
  return (
    <footer className="mt-16 w-full bg-primary-950 pb-16 text-background-100 md:pb-0">
      <div className="mx-auto grid grid-cols-1 gap-10 px-4 py-12 md:grid-cols-4 md:px-8 md:py-16">
        <div className="md:col-span-2">
          <div className="flex items-center gap-2.5">
            <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-accent-500 text-primary-950">
              <i className="ri-film-line text-xl" aria-hidden="true"></i>
            </span>
            <span className="font-heading text-lg font-bold text-background-50">
              《出轨的妻子》<span className="text-accent-500">hd</span>
            </span>
          </div>
          <p className="mt-5 max-w-md text-sm leading-relaxed text-background-300">
            专注《出轨的妻子》及相关高清影视作品的资源信息、剧情介绍与影评分享，帮助影迷快速查询、了解并筛选值得观看的好电影。
          </p>
          <p className="mt-4 text-xs leading-relaxed text-background-400">
            本站所有影视资源信息、剧情介绍、封面图片与评论均为虚构演示示例，不提供真实播放与下载服务，仅供学习与设计演示使用。
          </p>
        </div>

        <div>
          <h3 className="font-heading text-sm font-semibold text-background-50">电影分类</h3>
          <ul className="mt-4 space-y-3 text-sm">
            {quickCategories.map((item) => (
              <li key={item.name}>
                <Link
                  to={`/category?genre=${encodeURIComponent(item.name)}`}
                  className="text-background-300 transition-colors hover:text-accent-400 cursor-pointer"
                >
                  {item.name}片
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h3 className="font-heading text-sm font-semibold text-background-50">站点导航</h3>
          <ul className="mt-4 space-y-3 text-sm">
            <li>
              <Link to="/" className="text-background-300 transition-colors hover:text-accent-400 cursor-pointer">
                首页
              </Link>
            </li>
            <li>
              <Link to="/category" className="text-background-300 transition-colors hover:text-accent-400 cursor-pointer">
                电影分类
              </Link>
            </li>
            <li>
              <Link to="/search" className="text-background-300 transition-colors hover:text-accent-400 cursor-pointer">
                搜索影视
              </Link>
            </li>
            <li>
              <Link to="/about" className="text-background-300 transition-colors hover:text-accent-400 cursor-pointer">
                关于我们
              </Link>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-primary-800">
        <div className="mx-auto flex flex-col gap-2 px-4 py-6 text-xs text-background-400 md:flex-row md:items-center md:justify-between md:px-8">
          <p>© 2024 《出轨的妻子》hd · 高清影视资源及剧情介绍 · 演示站点</p>
          <p>所有内容均为虚构演示，不含真实影视资源</p>
        </div>
      </div>
    </footer>
  );
}